export default "__VITE_ASSET__BjHRK6mZ__"